var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFormInstanceNotificationConfigIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H3C2.73488 14.9997 2.4807 14.8942 2.29323 14.7068C2.10576 14.5193 2.0003 14.2651 2 14V2C2.0003 1.73488 2.10576 1.4807 2.29323 1.29323C2.4807 1.10576 2.73488 1.0003 3 1H13C13.2651 1.0003 13.5193 1.10576 13.7068 1.29323C13.8942 1.4807 13.9997 1.73488 14 2V14C13.9997 14.2651 13.8942 14.5193 13.7068 14.7068C13.5193 14.8942 13.2651 14.9997 13 15ZM3 2V14H13V2H3Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5L11 7.5V6.5L5 6.5V7.5Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H10V9H6V10Z",
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFormInstanceNotificationConfigIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/form-instance-notification-config-icon.6e41080bda83d72bbc7c4f9d583f3eda.svg";